define('page/join', [
    'utils/common'
], function (common) {
    'use strict';
    // banner form
    var nameEL = document.querySelector('#joinName')
    var phoneEl = document.querySelector('#joinPhone')
    var btnEl = document.querySelector('#joinSubmit')

    if (nameEL && phoneEl && btnEl) {
        btnEl.addEventListener('click', function () {
            common.submitForm([nameEL, phoneEl])
        })
    }
     

    // 我要加盟 form
    var nameEL2 = document.querySelector('#joinName2')
    var phoneEl2 = document.querySelector('#joinPhone2')
    var btnEl2 = document.querySelector('#joinSubmit2')
     
    if (nameEL2 && phoneEl2 && btnEl2) {
        btnEl2.addEventListener('click', function () {
            common.submitForm([nameEL2, phoneEl2])
        })
    }
});
